import type { FC } from 'react';
import { useEffect } from 'react';

import { useAudioTrigger } from '../../../controllers/audioController/hooks';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useNickNameFetcher } from '../../../store/apiHooks/useNickNameFetcher';
import { useCoreDispatch } from '../../../store/CoreStore';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { useNickNameInfoSlice } from '../../../store/slices/nickname/selectors';
import { nickNameInfoActions } from '../../../store/slices/nickname/slice';
import { ControlContainer } from '../../controls/controlContainer/ControlContainer';
import { IconButton } from '../../controls/iconButton/IconButton';
import { Icons } from '../../icons/iconNames';

import { NickNameEditFooterMessageConnected } from './NickNameFooterMessageConnected';

import styles from './NickNameSettings.module.css';

export const NickNameSettingsConnected: FC = () => {
  const { isNickNameInfoFetched, remainingAttempts, showNickNameSection } = useNickNameInfoSlice.getNickNameInfo();
  const screenName = useConfigSlice.playerConfig()?.screenName ?? '';
  const isPencilButtonDisplayed = isNickNameInfoFetched && !!remainingAttempts;
  const isFooterDisplayed = isNickNameInfoFetched && showNickNameSection;

  const dispatch = useCoreDispatch();
  const nickNameFetcher = useNickNameFetcher();
  const audioTrigger = useAudioTrigger();

  const handleEditNickName = (): void => {
    audioTrigger.play({ name: 'menuClick' });
    dispatch(nickNameInfoActions.setIsNickNameEditOpen(true));
  };

  useEffect(() => {
    if (!isNickNameInfoFetched) {
      nickNameFetcher();
    }
  }, [isNickNameInfoFetched, nickNameFetcher]);

  return (
    <>
      <ControlContainer
        label={
          <>
            <div className={styles.nickNameSettingsLabel}>
              <L10nText tk="SETTINGS_NICKNAME" />
            </div>
            <div>{screenName}</div>
          </>
        }
        offset
      >
        {isPencilButtonDisplayed ? (
          <div className={styles.nickNameSettingsPencilButton}>
            <IconButton ghost icon={Icons.Edit} onClick={handleEditNickName} />
          </div>
        ) : null}
      </ControlContainer>

      {isFooterDisplayed ? <NickNameEditFooterMessageConnected /> : null}
    </>
  );
};
